const Login = () => import('@/pages/auth/Login.vue');
const PasswordSet = () => import('@/pages/auth/PasswordSet.vue');
const PasswordReset = () => import('@/pages/auth/PasswordReset.vue');
const PasswordResetLink = () => import('@/pages/auth/PasswordResetLink.vue');
const Todo = () => import('@/pages/Todo.vue');

export default [
    {
        path: '/',
        name: 'login',
        component: Login,
        props: route => ({
            userId: parseInt(route.query.user)
        })
    },
    {
        path: '/home',
        name: 'home',
        redirect: '/services',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/password/set/:token?',
        name: 'passwordSet',
        component: PasswordSet,
        props: route => ({
            token: route.params.token,
            email: route.query.email
        })
    },
    {
        path: '/password/reset',
        name: 'passwordReset',
        component: PasswordReset
    },
    {
        path: '/password/reset/:token',
        name: 'passwordResetLink',
        component: PasswordResetLink,
        props: route => ({
            token: route.params.token,
            email: route.query.email
        })
    },
    {
        path: '/todo',
        name: 'todo',
        component: Todo,
        meta: {
            requiresAuth: true
        }
    }
];
